/*eslint-disable*/

import React, { useState } from "react";
import { FiBell, FiTrash2 } from "react-icons/fi";
import BeatLoader from "react-spinners/BeatLoader";

import FastAPIClient from "../../client";
import config from "../../config";

const client = new FastAPIClient(config);

interface Client {
    client_name: string;
}

interface Reminder {
    reminder_id: number;
    client: Client;
    title: string;
    note: string;
}

interface RemindersProps {
    reminders: Reminder[];
    setReminder: (updatedReminders?: Reminder[]) => void; // fetchReminder accepts an updated reminder list
}

const Reminders: React.FC<RemindersProps> = ({ reminders, setReminder }) => {
    const [showConfirm, setShowConfirm] = useState<boolean>(false);
    const [selectedReminder, setSelectedReminder] = useState<Reminder | null>(
        null
    );
    const [localReminders, setLocalReminders] = useState<Reminder[]>(reminders); // Local state to manage reminders
    const [isDeleting, setIsDeleting] = useState<boolean>(false); // New state for managing the deletion process

    const handleDeleteClick = (reminder: Reminder) => {
        setSelectedReminder(reminder);
        setShowConfirm(true);
    };

    const confirmDelete = async () => {
        if (selectedReminder) {
            setIsDeleting(true); // Start the deletion process

            try {
                await client.deleteReminder(selectedReminder.reminder_id);

                // Remove the deleted reminder from the UI before fetching the updated list
                const updatedReminders = localReminders.filter(
                    (reminder) =>
                        reminder.reminder_id !== selectedReminder.reminder_id
                );

                setShowConfirm(false);
                setSelectedReminder(null);

                // Update the local UI with the new list
                setLocalReminders(updatedReminders);

                // Pass the updated list to the parent to update the global state/data
                setReminder(updatedReminders); // Here we're passing the updated list to the parent
            } catch (error) {
                console.error("Error deleting reminder:", error);
            } finally {
                setIsDeleting(false); // Stop the deletion process
            }
        }
    };

    return (
        <div className="flex flex-col items-center w-full pl-5 pr-5 text-base text-black">
            {reminders.map((reminder) => (
                <li
                    key={reminder.reminder_id}
                    className="flex flex-row rounded-full bg-gold items-center w-full px-2 mt-1"
                >
                    <div className="flex text-sm w-1/12">
                        <FiBell />
                    </div>
                    <div className="flex flex-col text-xxs md:text-sm w-5/6 text-left py-1">
                        <div className="flex">
                            <strong className="mr-2 text-xxs font-semibold">
                                {reminder.client.client_name}
                            </strong>
                        </div>
                        <div className="mr-2 text-xxs flex">
                            {reminder.title}: {reminder.note}
                        </div>
                    </div>
                    <div
                        className="cursor-pointer"
                        onClick={() => handleDeleteClick(reminder)}
                    >
                        <FiTrash2 className="" />
                    </div>
                </li>
            ))}

            {showConfirm && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-5 rounded-lg shadow-md text-left">
                        <p className="text-xl">Supprimer ce rappel ?</p>
                        <p className="text-base mt-4">
                            Le rappel sera supprimé définitivement.
                        </p>
                        <div className="flex justify-center gap-4 mt-4">
                            <button
                                onClick={() => setShowConfirm(false)}
                                className="hover:bg-gray-100 px-4 py-2 rounded-full font-semibold"
                                disabled={isDeleting} // Disable the button during deletion
                            >
                                {isDeleting ? "" : "Annuler"}
                            </button>
                            <button
                                onClick={confirmDelete}
                                className="bg-rose-500 text-white px-4 py-2 rounded-full font-semibold"
                                disabled={isDeleting} // Disable the button during deletion
                            >
                                {isDeleting ? (
                                    <BeatLoader
                                        color="#ffffff"
                                        // loading={loading}
                                        // cssOverride={override}
                                        size={7}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"
                                    /> // Show the throbber while deleting
                                ) : (
                                    "Supprimer"
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Reminders;
